import { baseURL } from '../../axios/axios';
import styles from './index.module.scss';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { Button, Upload, message, Modal, Image } from 'antd';
import cx from 'classnames';
import { reduceStore } from './store';
import { observer } from 'mobx-react';
import { QueryOrder } from '../Buy/QueryOrder';
import { useNavigate } from 'react-router-dom';
import upload from './assets/upload.png';
import word from './assets/word.png';
import aigc from './assets/aigc.png';
import search from './assets/search.png';
import success from './assets/success.png';
import { AIGCLIST, LUNWEN_LIST } from './const';
import helpBaogao from '../../assets/helpBaogao.png';
import helpJiangchong from '../../assets/helpJiangchong.png';
import { useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { useDevice } from '../../hooks/useDevice';

const { Dragger } = Upload;
export const Step1 = observer(() => {
    const [modal, contextHolder] = Modal.useModal();
    const props = {
        accept: '.pdf,.doc,.docx,.html',
        name: 'file',
        multiple: false,
        maxCount: 1,
        action: baseURL + 'ai/ai/jc/upload',
        data() {
            const inviter = window.localStorage.getItem('inviter');
            return {
                inviter: inviter || null,
                aigcType: selectedTags.find((it) => it.selected)?.value || null,
            };
        },
        onChange(info) {
            const { status } = info.file;
            if (status !== 'uploading') {
                reduceStore.onStep1FileChange(info.file);
            }
            if (status === 'done') {
            } else if (status === 'error') {
                message.error(`${info.file.response.msg}`);
            }
        },
        beforeUpload() {
            return new Promise((resolve, reject) => {
                modal.confirm({
                    className: styles.uploadConfirm,
                    title: '确认上传文档',
                    icon: <ExclamationCircleFilled />,
                    okButtonProps: {
                        className: 'bg-primary  text-white',
                    },
                    content:
                        '解析此文档可能需要访问您的文档内容，我们将严格保障每一个用户文件的安全性，绝不会泄露、篡改或滥用您的文件，您确定要授权此操作吗？',
                    onOk() {
                        resolve();
                    },
                    onCancel() {
                        resolve(Upload.LIST_IGNORE);
                    },
                });
            });
        },
        onDrop(e) {
            console.log('Dropped files', e.dataTransfer.files);
        },
    };

    function showHelpDownload(data) {
        // 手机上三张引导图竖排、宽度占满弹窗；桌面保持横排
        const narrow = window.innerWidth < 768;
        Modal.info({
            title: data.title,
            footer: null,
            closable: true,
            maskClosable: true,
            width: 1115,
            content: (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: narrow ? 'column' : 'row',
                        alignItems: 'center',
                        gap: narrow ? 16 : 15,
                        marginTop: '10px',
                    }}
                >
                    {data.imgs.map((d, idx) => {
                        return (
                            <div
                                key={idx}
                                style={{
                                    fontWeight: 500,
                                    textAlign: 'center',
                                    width: narrow ? '100%' : undefined,
                                }}
                            >
                                <Image
                                    src={d.src}
                                    height={narrow ? undefined : 239}
                                    width={narrow ? '100%' : undefined}
                                />
                                <div>
                                    【{idx + 1}】{d.step}
                                </div>
                            </div>
                        );
                    })}
                </div>
            ),
        });
    }

    function resetUpload() {
        reduceStore.onStep1FileChange('');
    }

    function onQuery() {
        QueryOrder({
            confirm: (orderNo) => {
                return new Promise((resolve, reject) => {
                    if (!orderNo) {
                        message.info('请输入订单号');
                        reject();
                        return;
                    }
                    reduceStore.onStep3GetOrderInfo({ orderNo }).then(() => {
                        resolve();
                        window.open(`${window.location.href}?o=${orderNo}`);
                    });
                });
            },
        });
    }

    const reducesContents = [
        {
            label: '知网',
            value: 'zw',
            selected: true,
        },
        {
            label: '维普',
            value: 'wp',
            selected: false,
        },
        // {
        //     label: '万方',
        //     value: 'wf',
        //     selected: false,
        // },
        // {
        //     label: '格子达',
        //     value: 'gzd',
        //     selected: false,
        // },
    ];

    const [selectedTags, setSelectedTags] = useState(reducesContents);

    const handleTagSelect = (tagValue) => {
        const updatedTags = selectedTags.map((tag) => ({
            ...tag,
            selected: tag.value === tagValue,
        }));
        setSelectedTags(updatedTags);
    };

    const navigate = useNavigate();
    const { isMobile } = useDevice();

    return (
        <div className="w-full lg:mx-auto lg:w-full">
            {contextHolder}
            {/*banner部分*/}
            <div className="flex flex-col lg:flex-col lg:justify-between lg:gap-4">
                {/*上方*/}
                <div className={styles.titleBefore}>内容</div>
                <div className="flex gap-3">
                    {selectedTags.map((item) => (
                        <div
                            key={item.value}
                            onClick={() => handleTagSelect(item.value)}
                            className={twMerge(
                                'min-w-[100px] cursor-pointer rounded-md px-6 py-2 text-center transition-colors duration-200',
                                item.selected
                                    ? 'bg-primary text-white'
                                    : 'bg-[#F8FBFF] text-[#414C6F]',
                            )}
                        >
                            {item.label}
                        </div>
                    ))}
                </div>
                <div className={styles.titleBefore}>上传内容</div>
                <div className="mb-4 w-full rounded-[12px] bg-white lg:mb-0 lg:h-full lg:flex-1 lg:bg-white">
                    {reduceStore.step1.file ? (
                        <div className={styles.hasFile}>
                            <img src={success} className={styles.successImg} />
                            <div className={styles.successTip}>上传成功</div>
                            <div className={styles.successTip}>{reduceStore.step1.file.name}</div>
                            <div className={styles.successBtns}>
                                <Button
                                    onClick={resetUpload}
                                    size="large"
                                    className={styles.leftBtn}
                                >
                                    重新上传
                                </Button>
                                <Button
                                    onClick={() => {
                                        navigate('/reduce');
                                        reduceStore.toStep2(reduceStore.step1.file);
                                    }}
                                    type="primary"
                                    size="large"
                                >
                                    确认上传
                                </Button>
                            </div>
                        </div>
                    ) : (
                        <div className="mx-auto lg:h-[320px]">
                            <Dragger {...props}>
                                <>
                                    <div className="flex justify-center">
                                        <img src={upload} />
                                    </div>
                                    <div className="mb-2 mt-2 text-base text-[#333] lg:mb-8">
                                        点击上传或拖拽文件到此处上传
                                    </div>
                                    <div className="flex flex-col gap-3 px-4 lg:flex-row lg:justify-between lg:px-8">
                                        <div className="flex h-[65px] w-full items-center rounded-[8px] bg-white p-2 lg:h-[88px] lg:flex-1 lg:p-4">
                                            <img className="mr-2 h-8 w-8" src={word} />
                                            <div>
                                                <div className="text-start">全文原稿</div>
                                                <div className="text-start text-xs text-[#999]">
                                                    .docx
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex h-[65px] w-full items-center rounded-[8px] bg-white p-2 lg:h-[88px] lg:flex-1 lg:p-4">
                                            <img className="mr-2 h-8 w-8" src={aigc} />
                                            <div>
                                                <div className="text-start">AIGC检测报告</div>
                                                <div className="text-start text-xs text-[#999]">
                                                    知网、维P
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex h-[65px] w-full items-center rounded-[8px] bg-white p-2 lg:h-[88px] lg:flex-1 lg:p-4">
                                            <img className="mr-2 h-8 w-8" src={search} />
                                            <div>
                                                <div className="text-start">全文原稿</div>
                                                <div className="text-start text-xs text-[#999]">
                                                    知W、维P、万F、PaperOK、PaperRight
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            </Dragger>
                        </div>
                    )}
                    <div className="mt-4 text-center text-sm text-[#999]">
                        <div className="mt-12">
                            灵感严格遵守保密规定，不会收录、泄露您的任何信息，您提交的信息可随时删除，请放心使用。
                        </div>
                    </div>
                </div>
                {/*下方*/}
                <div className={cx(styles.card, styles.helpBox)}>
                    <div className="border-b-[1px] pb-3 text-[18px] font-bold">帮助中心</div>
                    <div className="flex flex-col gap-4 md:flex-row">
                        <div className="w-full md:flex-1">
                            <div
                                className={styles.tip}
                                style={{
                                    paddingTop: '16px',
                                }}
                            >
                                <div className="flex gap-1">
                                    <img className="h-4 w-4" src={helpBaogao} alt="" />
                                    <span className="text-[14px] text-[#333]">AI报告怎么传？</span>
                                </div>
                            </div>
                            <div className={styles.btnBox}>
                                {AIGCLIST.map((it, idx) => (
                                    <Button
                                        key={idx}
                                        className={styles.btn}
                                        onClick={() => showHelpDownload(it)}
                                    >
                                        {it.btn}
                                    </Button>
                                ))}
                            </div>
                        </div>
                        <div className="w-full md:flex-1">
                            <div className={styles.tip} style={{ marginTop: '20px' }}>
                                <div className="flex gap-1">
                                    <img className="h-4 w-4" src={helpJiangchong} alt="" />
                                    <span className="text-[14px] text-[#333]">
                                        全文查重报告怎么传?
                                    </span>
                                </div>
                            </div>
                            <div className={styles.btnBox}>
                                {LUNWEN_LIST.map((it, idx) => (
                                    <Button
                                        key={idx}
                                        className={styles.btn}
                                        onClick={() => showHelpDownload(it)}
                                    >
                                        {it.btn}
                                    </Button>
                                ))}
                            </div>
                        </div>
                        <div className="w-full md:flex-1">
                            <div className={styles.tip} style={{ marginTop: '20px' }}>
                                <div className="flex gap-1">
                                    <img className="h-4 w-4" src={helpJiangchong} alt="" />
                                    <span className="text-[14px] text-[#333]">查询降重记录</span>
                                </div>
                            </div>
                            <div className={styles.btnBox}>
                                <Button className={styles.btn} onClick={onQuery}>
                                    查询记录
                                </Button>
                            </div>
                        </div>
                        <div className="w-full md:flex-1">
                            <div className={styles.tip} style={{ marginTop: '20px' }}>
                                <div className="flex gap-1">
                                    <img className="h-4 w-4" src={helpJiangchong} alt="" />
                                    <span className="text-[14px] text-[#333]">案例展示</span>
                                </div>
                            </div>
                            <div className={styles.btnBox}>
                                <Button className={styles.btn} onClick={onQuery}>
                                    案例展示
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});
